import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import { usePermissions } from '@/hooks/usePermissions';
import { useAuth } from '@/contexts/AuthContext';
import { PageLoader } from '@/components/LazyPages';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminGuard = ({ children }: AdminRouteProps) => {
  const { isLoading } = useAuth();
  const { canAccessAdminPages } = usePermissions();
  if (isLoading) return <PageLoader />;
  if (!canAccessAdminPages()) return <Navigate to="/not-found" replace />;
  return <>{children}</>;
};

const AdminRoute = ({ children }: AdminRouteProps) => (
  <ProtectedRoute>
    <AdminGuard>{children}</AdminGuard>
  </ProtectedRoute>
);

export default AdminRoute;
